module.exports = __webpack_public_path__ + "static/media/c3payToBank.a9aa10af.svg";